(() => {
  'use strict';
  const menuButton = document.querySelector('.menu-toggle');
  const navigation = document.querySelector('.nav');
  const closeMenu = () => {
    menuButton?.setAttribute('aria-expanded', 'false');
    navigation?.classList.remove('is-open');
  };
  menuButton?.addEventListener('click', () => {
    const open = menuButton.getAttribute('aria-expanded') !== 'true';
    menuButton.setAttribute('aria-expanded', String(open));
    navigation?.classList.toggle('is-open', open);
  });
  navigation?.querySelectorAll('a').forEach(link => link.addEventListener('click', closeMenu));
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape') {
      const wasOpen = menuButton?.getAttribute('aria-expanded') === 'true';
      closeMenu();
      if (wasOpen) menuButton.focus();
    }
  });

  const products = new WeakMap();
  const optionRank = name => {
    const rank = ['design', 'size', 'color', 'colour'].indexOf(name.toLowerCase().trim());
    return rank < 0 ? 4 : rank;
  };
  const initializeProduct = section => {
    if (products.has(section)) return;
    const form = section.querySelector('.native-form');
    const nativeSelect = form?.querySelector('[data-native-variant]');
    const button = form?.querySelector('[data-add-button]');
    if (!form || !nativeSelect || !button) return;
    const variants = Array.from(nativeSelect.options, option => ({
      id: option.value,
      title: option.dataset.title,
      options: JSON.parse(option.dataset.options),
      available: option.dataset.available === 'true',
      data: option.dataset,
      element: option
    }));
    if (!variants.length) return;
    const picker = form.querySelector('[data-option-picker]');
    const fields = Array.from(picker?.querySelectorAll('[data-option-position]') || [], field => ({
      element: field,
      index: Number(field.dataset.optionPosition),
      name: field.dataset.optionName,
      select: field.querySelector('[data-product-option]'),
      values: Array.from(field.querySelector('select').options, option => option.value)
    })).sort((a, b) => optionRank(a.name) - optionRank(b.name) || a.index - b.index);
    const quantity = form.querySelector('[name="quantity"]');
    const price = section.querySelector('[data-native-price]');
    const image = section.querySelector('[data-product-image] img');
    const selection = section.querySelector('[data-product-selection]');
    const included = section.querySelector('[data-product-included]');
    const status = form.querySelector('[data-product-status]');
    let selected = variants.find(variant => variant.id === nativeSelect.value) || variants[0];
    let submitting = false;

    const updateProduct = (variant, announce = false, updateUrl = false) => {
      selected = variant;
      button.disabled = !variant?.available || submitting;
      button.textContent = submitting ? button.dataset.adding : variant?.available ? button.dataset.addText : variant ? button.dataset.soldOut : button.dataset.unavailable;
      if (!variant) {
        nativeSelect.value = '';
        if (status) status.textContent = button.dataset.unavailable;
        return;
      }
      nativeSelect.value = variant.id;
      if (price) price.textContent = variant.data.price;
      if (selection) selection.textContent = variant.title;
      if (included) included.textContent = variant.data.included;
      if (image && variant.data.image) {
        image.src = variant.data.image;
        image.srcset = variant.data.imageSrcset;
        image.width = Number(variant.data.imageWidth);
        image.height = Number(variant.data.imageHeight);
        image.alt = variant.data.imageAlt;
      }
      if (quantity) {
        quantity.min = variant.data.min || '1';
        quantity.step = variant.data.step || '1';
        if (variant.data.max) quantity.max = variant.data.max;
        else quantity.removeAttribute('max');
        const min = Number(quantity.min);
        const step = Number(quantity.step);
        const max = quantity.max ? Number(quantity.max) : Infinity;
        const current = Number(quantity.value);
        const valid = Number.isInteger(current) && current >= min && current <= max && (current - min) % step === 0;
        if (!valid) quantity.value = String(min);
      }
      if (status) status.textContent = announce ? `${variant.title} — ${variant.data.price}${variant.available ? '' : ` — ${button.dataset.soldOut}`}` : '';
      if (updateUrl) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        url.searchParams.delete('option_values');
        window.history.replaceState(window.history.state, '', url);
      }
    };

    const syncPicker = (changedAt = -1, preferredVariant = null) => {
      let candidates = variants;
      for (let position = 0; position < fields.length; position++) {
        const field = fields[position];
        const wanted = preferredVariant ? preferredVariant.options[field.index] : field.select.value;
        const choices = field.values.filter(value => candidates.some(variant => variant.options[field.index] === value));
        const available = value => candidates.some(variant => variant.options[field.index] === value && variant.available);
        const preserve = choices.includes(wanted) && (position <= changedAt || changedAt < 0 || available(wanted));
        const chosenValue = preserve ? wanted : choices.find(available) || choices[0];
        field.select.replaceChildren(...choices.map(value => {
          const option = document.createElement('option');
          option.value = value;
          option.textContent = available(value) ? value : `${value} — ${button.dataset.soldOut}`;
          option.disabled = !available(value);
          option.selected = value === chosenValue;
          return option;
        }));
        candidates = candidates.filter(variant => variant.options[field.index] === chosenValue);
      }
      return candidates[0] || null;
    };

    if (fields.length) {
      fields.forEach((field, position) => {
        picker.append(field.element);
        field.element.querySelector('[data-option-step]').textContent = `${position + 1}`;
        field.select.value = selected.options[field.index];
        field.select.addEventListener('change', () => updateProduct(syncPicker(position), true, true));
      });
      syncPicker(-1, selected);
      picker.hidden = false;
      form.querySelector('[data-native-variant-field]').hidden = true;
    }
    nativeSelect.addEventListener('change', () => {
      const variant = variants.find(item => item.id === nativeSelect.value);
      if (fields.length && variant) syncPicker(-1, variant);
      updateProduct(variant, true, true);
    });
    form.addEventListener('submit', event => {
      if (submitting || !selected?.available) {
        event.preventDefault();
        return;
      }
      submitting = true;
      button.disabled = true;
      button.textContent = button.dataset.adding;
      form.setAttribute('aria-busy', 'true');
    });
    const reset = () => {
      submitting = false;
      form.removeAttribute('aria-busy');
      updateProduct(selected);
    };
    const loadFromUrl = () => {
      const id = new URL(window.location.href).searchParams.get('variant');
      const variant = variants.find(item => item.id === id);
      if (!variant) return;
      if (fields.length) syncPicker(-1, variant);
      updateProduct(variant);
    };
    products.set(section, { reset, loadFromUrl });
    updateProduct(selected);
  };
  const initializeProducts = scope => scope.querySelectorAll('[data-ogp-product]').forEach(initializeProduct);
  initializeProducts(document);
  document.addEventListener('shopify:section:load', event => initializeProducts(event.target));
  window.addEventListener('pageshow', () => document.querySelectorAll('[data-ogp-product]').forEach(section => products.get(section)?.reset()));
  window.addEventListener('popstate', () => document.querySelectorAll('[data-ogp-product]').forEach(section => products.get(section)?.loadFromUrl()));
})();
